// src/components/styled/DetailComponents.js
import styled from 'styled-components';
import { Card } from './GridComponents';

export const DetailContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  gap: ${props => props.theme.spacing(3)};
  grid-template-columns: 2fr 1fr;
  
  @media (max-width: 968px) {
    grid-template-columns: 1fr;
  }
`;

export const DetailHeader = styled.div`
  background: ${props => props.theme.colors.surface};
  border-radius: ${props => props.theme.borderRadius};
  padding: ${props => props.theme.spacing(3)};
  margin-bottom: ${props => props.theme.spacing(3)};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  grid-column: 1 / -1;
`;

export const DetailTitle = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing(2)};
  margin-bottom: ${props => props.theme.spacing(3)};

  h1 {
    margin: 0;
    color: ${props => props.theme.colors.primary};
    font-size: ${props => props.theme.typography.fontSize.xlarge};
  }
`;

export const DetailSection = styled(Card)`
  padding: ${props => props.theme.spacing(3)};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(2)};
  margin: 1em 0em;

  h3 {
    color: ${props => props.theme.colors.primary};
    margin: 0 0 ${props => props.theme.spacing(2)} 0;
    display: flex;
    align-items: center;
    gap: ${props => props.theme.spacing(1)};
  }
`;

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: ${props => props.theme.spacing(3)};
`;

export const DetailGridSeparator = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: ${props => props.theme.spacing(3)};
  margin-bottom: ${props => props.theme.spacing(3)};
  padding-bottom: ${props => props.theme.spacing(2)};
  border-bottom: solid 1px ${props => props.theme.colors.inputGray};
`

export const DetailField = styled.div`
  label {
    display: block;
    font-size: ${props => props.theme.typography.fontSize.small};
    color: ${props => props.theme.colors.textSecondary};
    margin-bottom: ${props => props.theme.spacing(1)};
  }

  span {
    display: block;
    color: ${props => props.theme.colors.textPrimary};
    font-size: ${props => props.theme.typography.fontSize.medium};
  }
`;

export const ActionBar = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing(2)};
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: stretch;
    button {
      flex: 1;
    }
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing(1)};
  padding: ${props => props.theme.spacing(1.5)} ${props => props.theme.spacing(3)};
  border: none;
  border-radius: ${props => props.theme.borderRadius};
  background: ${props => props.variant === 'primary' 
    ? props.theme.colors.primary 
    : props.variant === 'danger'
    ? props.theme.colors.error
    : props.theme.colors.surface};
  color: ${props => props.variant === 'primary' || props.variant === 'danger'
    ? props.theme.colors.black
    : props.theme.colors.textPrimary};
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: ${props => props.theme.typography.fontSize.medium};
  font-weight: ${props => props.theme.typography.fontWeight.medium};

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }

  svg {
    font-size: 1.2em;
  }
`;